import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { StoreStatus } from 'src/shared/types/StoreStatus';
import { useAppDispatch } from 'src/store';
import {
  selectStoreStatus,
  selectInitialized,
  thunkLoadUserRules,
  selectUserRuleEntity,
  // UserRuleUpdateUseReq,
} from 'src/store/user/userRule';

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUserRuleStore = (updateByForceArg = false) => {
  const [updateByForce, setUpdateByForce] = useState(updateByForceArg);

  const status = useSelector(selectStoreStatus);
  const initialized = useSelector(selectInitialized);
  const userRuleEntity = useSelector(selectUserRuleEntity);

  const dispatch = useAppDispatch();

  const boundLoadUserRules = useCallback(() => dispatch(thunkLoadUserRules()), [dispatch]);

  useEffect(() => {
    if (status === StoreStatus.IDLE) {
      setUpdateByForce(false);
      boundLoadUserRules();
    } else if (updateByForce && (status === StoreStatus.DONE || status === StoreStatus.FAILED)) {
      setUpdateByForce(false);
      boundLoadUserRules();
    }
  }, [boundLoadUserRules, status, updateByForce]);

  return {
    initialized,
    userRuleEntity,
    loadUserRules: boundLoadUserRules,
  };
};

export default useUserRuleStore;
